import React, { Component } from 'react'
import { Marker, Popup } from 'react-leaflet';
import { Link, withRouter } from 'react-router-dom';
import { ClockIcon, iconStop, iconStopWheelChair, InformationIcon, LocationAIcon, LocationBIcon, WheelChairIcon } from '../icons/Icons';

import "../styles/Marker.css"

class StationMarker extends Component {
    render() {
        return (
            <Marker
                position={[this.props.station.coords.lat, this.props.station.coords.long]}
                icon={
                    (this.props.station.elevators && this.props.station.elevators.length > 0) || this.props.station.isAccessible ?
                        iconStopWheelChair :
                        iconStop
                }
            >
                <Popup className='marker'>
                    <h5 style={{fontSize: "20px"}}>{this.props.station.name}, {this.props.station.city}</h5>
                    {(this.props.station.elevators && this.props.station.elevators.length > 0) || (this.props.station.escalators && this.props.station.escalators.length > 0) ? (
                        <Link to={{
                            pathname: "/accessible",
                            state: {
                                station: this.props.station,
                                return: "/departureDetail"
                            }
                        }}
                            style={{ textDecoration: 'none', color: "#003366", fontSize: '16px', display: 'flex', margin: '5px 0' }}>
                            <InformationIcon style={{ height: "20px" }} /> Infos zu Aufzügen und Fahrtreppen
                        </Link>
                    ) : null}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}
                            onClick={() => { this.props.setOrigin(this.props.station); this.props.history.push("/") }}
                            onTouchEnd={() => { this.props.setOrigin(this.props.station); this.props.history.push("/") }}>
                            <p style={{ margin: '2px' }}>Von hier</p>
                            <LocationAIcon style={{ height: "40px" }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: "column", textAlign: 'center' }}
                            onClick={() => { this.props.setDestination(this.props.station); this.props.history.push("/") }}
                            onTouchEnd={() => { this.props.setDestination(this.props.station); this.props.history.push("/") }}>
                            <p style={{ margin: '2px' }}>Hierher</p>
                            <LocationBIcon style={{ height: "40px" }} />
                        </div>
                        <div style={{ display: 'fley', flexDirection: 'row', textAlign: 'center' }}
                            onClick={() => { this.props.history.push("/departure?stopId=" + this.props.station.id); window.location.reload(false); }}
                            onTouchEnd={() => { this.props.history.push("/departure?stopId=" + this.props.station.id); window.location.reload(false); }}>
                            <p style={{ margin: '2px' }}>Abfahrten</p>
                            <ClockIcon style={{ height: "40px" }} />
                        </div>
                    </div>
                </Popup>
            </Marker>
        )
    }
}

export default withRouter(StationMarker);